import React, { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import "./FastBooking.css";
import CircularSpinner from 'mmbclient/Components/CircularSpinner';
import { getCookie } from 'mmbclient/Common/CommonFunctions';
import { AD, APP_TYPE_COOKIE_NAME, EP, MMB, MMB_LIVE, USER_TYPE_COOKIE_NAME } from 'mmbclient/Common/CommonVariable';
import CreditBookingController from './CreditBookingController';
import { ToastContainer } from 'react-toastify';

function CreditBooking() {
    const {formValues,loading,setFormValues,filteredOriginPincodes,setFilteredOriginPincodes,filteredDestPincodes,setFilteredDestPincodes,handleBlurPincode,handleInputChange,clientOption,service,network,activeOriginIndex,setActiveOriginIndex,selectOriginPincode,selectDestPincode,setActiveDestIndex,activeDestIndex,handleDecimalInputChange,handleNumberInputChange,checkValidation,resetAction,awbBlurHandle,betterLoggerFunction,weigthDimension,enterDimensionMMB,handleWeigthDecimalInputChange,dimensionList,showDimensionWeigthModal,setShowDimensionWeigthModal,disableAwb,handleWeigthDimenstionFocus,isSaveDisable,removeEnteredDimension,handleBlurOfVolumeWt,printDocket,handleBlurReceiver,handleBlurSender,insurType,setFilteredReceiverPincodes,filterReceiverPincodes,setFilteredSenderPincodes,filterSenderPincodes,activeReceiverIndex,setActiveReceiverIndex,activeSenderIndex,setActiveSenderIndex,selectReceiverPincode,selectSenderPincode,filteredSenderPincodes,filteredReceiverPincodes,OnBlurInsValue,handleEnterAsTab, dateRef,originPincodeRef,destPincodeRef,senderPincodeRef,receiverPincodeRef,handleEntryChange,isNew,isModify,entryType,handleNewModifyAwb,handleEnterAsTabForVolumatric,clientSelfSender,focusVolumeWeigth,setFocusVolumeWeigth} = CreditBookingController();
    const [showModal, setShowModal] = useState(false);
    const isNA = formValues.insurance === 'NA';
    const pcsRef = useRef(null);
    useEffect(() => {
    if (showDimensionWeigthModal) {
            setTimeout(() => {
                pcsRef.current?.focus();
            }, 100);
        }
    }, [showDimensionWeigthModal]);

    const volRef = useRef(null);
    
    useEffect(() => {
    if (focusVolumeWeigth) {
            setTimeout(() => {
                volRef.current?.focus();
            }, 100);
        }
    }, [focusVolumeWeigth]);


    useEffect(()=>{

        const type = formValues.insurance;

        setFormValues(prev => {
            if(type==='NA'){
                return {
                    ...prev,
                    'insInvoiceNo':'',
                    'insValue':0
                }
            }else{
                return {
                    ...prev
                }
            }
        });
        

    },[formValues.insurance])

   return (
    <>   

        {/* Bootstrap Modal */}
        <div className={`modal fade ${showModal ? 'show' : ''}`} style={{ display: showModal ? 'block' : 'none' }} tabIndex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden={!showModal}>
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    {/* <div className={`modal-header alert-${modalType}`}> */}
                    <div className={`modal-header alert-primary d-flex justify-content-between`}>
                        <h5 className="modal-title" id="modalLabel">Alert</h5>
                        <button type="button" className="close" onClick={() => setShowModal(false)} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {/* {modalMessage} */}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div onMouseOver={betterLoggerFunction}>
            <div className='container'>
                {loading && <CircularSpinner />}
                <div className='row mt-2 align-items-center'>
                    <div className="col-md-2">
                        <div className="form-check form-check-inline">
                            <input
                                type="radio"
                                name="entryType"
                                id='new'
                                value="new"
                                className="form-check-input"
                                checked={entryType === "new"}
                                onChange={handleEntryChange}
                                style={{fontSize:'12px'}}
                            />
                            <label htmlFor="new" className="form-check-label" style={{fontSize:'12px'}}>New</label> 
                        </div>

                        <div className="form-check form-check-inline">
                            <input
                                type="radio"
                                name="entryType"
                                id='modify'
                                value="modify"
                                className="form-check-input"
                                checked={entryType === "modify"}
                                onChange={handleEntryChange}
                                style={{fontSize:'12px'}}
                            />
                            <label htmlFor="modify" className="form-check-label" style={{fontSize:'12px'}}>Modify</label> 
                        </div>

                    </div>

                    <div className="col-md-8 mb-2">
                        <h3 className='text-center' style={{fontSize:'20px'}}>Credit Booking</h3>
                    </div>
                </div>
                
                <section className="border mb-4 form-control">
                    <form className='' onKeyDown={handleEnterAsTab}>
                        <div className='row mb-2 align-items-center'>
                            <div className='col-md-2'>
                                <label className='form-label small-label'>
                                    Awb No.
                                    <span className='text-danger'>*</span>
                                </label>
                                <input
                                type="text"
                                name="awbNo"
                                className="form-control small-input"
                                placeholder="Enter awb no."
                                value={formValues.awbNo}
                                onChange={handleInputChange}
                                // onBlur={handleNewModifyAwb}
                                disabled = {disableAwb}
                                maxLength={20}
                                
                                /> 
                            </div>

                            {/* <div className='col-md-2 mb-2'>
                                <label className='form-label'>
                                    Forwarding No.
                                </label> 
                                <input 
                                type='text' 
                                name="forwardingNo"
                                className='form-control' 
                                placeholder='Enter forwarding no.'
                                maxLength={20}
                                value={formValues.forwardingNo}
                                onChange={handleInputChange}/>
                            </div>   */}

                            <div className='col-md-2'>
                                <label className='form-label small-label'>
                                    Date
                                </label>
                                <DatePicker 
                                selected={formValues.date}
                                name='date' 
                                onChange={(date)=> {
                                    setFormValues(prev=>({
                                        ...prev,
                                        date:date
                                    }))
                                }}
                                ref={dateRef}
                                className='form-control small-input'
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                                maxDate={new Date()}
                                />
                            </div>

                            {
                                (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)?
                                <div className='col-md-4'>
                                <label className='form-label small-label'>Client
                                    <span className='text-danger'>*</span>
                                </label>
                                <select className='form-control small-input'
                                value={formValues.client}
                                name='client'
                                onChange={e=>{
                                    // setClient(e.target.value)
                                    handleInputChange(e);
                                    }}>
                                    {clientOption.length>0 && 
                                    clientOption.map((option,index)=>(
                                        <option key={index} value={option}>{option}</option>
                                    ))}
                                </select>
                            </div>
                            :
                            <div className='col-md-4 '>
                                <label className='form-label small-label'>Client
                                    <span className='text-danger'>*</span>
                                </label>
                                <select className='form-control small-input'
                                value={formValues.client}
                                name='client'
                                onChange={e=>{
                                    // setClient(e.target.value)
                                    handleInputChange(e);
                                    }}>
                                    {clientOption.length>0 && 
                                    clientOption.map((option,index)=>(
                                        <option key={index} value={option}>{option}</option>
                                    ))}
                                </select>
                                {/* <input name = "client" value={client} onChange={handleInputChange} className='form-control' disabled/> */}
                            </div>
                            }

                            <div className='col-md-4'>
                                <label className='form-label small-label'>
                                    Sub Client
                                </label>
                                <input type='text' 
                                name='subClient'
                                value={formValues.subClient}
                                onChange={handleInputChange}
                                maxLength={30}
                                className='form-control small-input' placeholder='Enter sub client'/>
                            </div>

                            <div className='col-md-2'>
                                <label className='form-label small-label'>Network
                                    <span className='text-danger'>*</span>
                                </label>
                                <select className='form-control small-input'
                                name='network'
                                value={formValues.network}
                                onChange={handleInputChange}>
                                    {network.length>0 &&
                                    network.map((item,index)=>(
                                        <option key={index} value={item}>{item}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='col-md-2'>
                                <label className='form-label small-label'>Service
                                    <span className='text-danger'>*</span>
                                </label>
                                <select className='form-control small-input'
                                value={formValues.service}
                                name='service'
                                onChange={e=>{
                                    handleInputChange(e)
                                }}>
                                    {service.length>0 &&
                                    service.map((item,index)=>(
                                        <option key={index} value={item}>{item}</option>
                                    ))};
                                </select>
                            </div>

                            <div className='col-md-2'>
                                <label className='form-label small-label'>Origin Pincode
                                    <span className='text-danger'>*</span>
                                </label>
                                <div style={{position:"relative"}}>
                                    <input 
                                    className='form-control small-input' 
                                    name='originPincode'
                                    autoComplete='off'
                                    ref={originPincodeRef}
                                    placeholder='Enter origin pincode'
                                    value={formValues.originPincode}
                                    onChange={e=>{
                                        handleInputChange(e);
                                        setActiveOriginIndex(-1);
                                    }}
                                    
                                    onBlur={e=>{
                                        handleBlurPincode("originPincode");
                                        setTimeout(() => setFilteredOriginPincodes([]), 100);
                                    }}
                                    onKeyDown={(e)=>{
                                        if(e.key==="Tab"){
                                            setFilteredOriginPincodes([]);
                                            return;
                                        }
                                        else if (e.key === 'ArrowDown') {
                                            e.preventDefault();
                                            setActiveOriginIndex((prev) =>
                                                prev < filteredOriginPincodes.length - 1 ? prev + 1 : prev
                                            );
                                        } else if (e.key === 'ArrowUp') {
                                            e.preventDefault();
                                            setActiveOriginIndex((prev) => (prev > 0 ? prev - 1 : 0));
                                        } 
                                        // else if (e.key === 'Enter') {
                                            // e.preventDefault();
                                            // if (
                                            //     activeOriginIndex >= 0 &&
                                            //     activeOriginIndex < filteredOriginPincodes.length
                                            // ) {
                                            //     selectOriginPincode(filteredOriginPincodes[activeOriginIndex]);
                                            // }
                                        // }
                                    }}
                                    />
                                    {filteredOriginPincodes.length>0 && (
                                        <ul className='autocomplete'>
                                            {filteredOriginPincodes.map((pin,index)=>(
                                                <li 
                                                className={index === activeOriginIndex?"active":""} 
                                                onMouseDown={() => selectOriginPincode(pin)}
                                                key={index}
                                                >{pin}</li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <div className='col-md-2'>
                                <label className='form-label small-label'>Origin City</label>
                                <input type='text' className='form-control small-input'
                                name="originCity"
                                value={formValues.originCity}
                                onChange={handleInputChange}
                                
                                disabled/>
                            </div>
        {/* simple right now */}
                            <div className='col-md-2'>
                                <label className='form-label small-label'>Destination Pincode
                                    <span className='text-danger'>*</span>
                                </label>
                                <div style={{position:"relative"}}>
                                    <input 
                                    className='form-control small-input' 
                                    name = "destPincode" 
                                    autoComplete='off'
                                    ref={destPincodeRef}
                                    placeholder='Enter Destination pincode'
                                    value={formValues.destPincode}
                                    onChange={e=>{
                                        handleInputChange(e);
                                        setActiveDestIndex(-1);
                                    }}
                                    onBlur={e=>{
                                        handleBlurPincode("destPincode");
                                        setTimeout(() => setFilteredDestPincodes([]), 100);
                                    }}
                                    onKeyDown={(e)=>{
                                        if(e.key==="Tab"){
                                            setFilteredOriginPincodes([]);
                                            return;
                                        }
                                        else if (e.key === 'ArrowDown') {
                                            e.preventDefault();
                                            setActiveDestIndex((prev) =>
                                                prev < filteredDestPincodes.length - 1 ? prev + 1 : prev
                                            );
                                        } else if (e.key === 'ArrowUp') {
                                            e.preventDefault();
                                            setActiveDestIndex((prev) => (prev > 0 ? prev - 1 : 0));
                                        } 
                                        // else if (e.key === 'Enter') {
                                        //     e.preventDefault();
                                        //     if (
                                        //         activeDestIndex >= 0 &&
                                        //         activeDestIndex < filteredDestPincodes.length
                                        //     ) {
                                        //         selectDestPincode(filteredDestPincodes[activeDestIndex]);
                                        //     }
                                        // }
                                    }}
                                    />
                                    {filteredDestPincodes.length>0 && (
                                        <ul className='autocomplete'>
                                            {filteredDestPincodes.map((pin,index)=>(
                                                <li className={activeDestIndex===index?"active":""} key={index}
                                                onMouseDown={() => selectDestPincode(pin)}
                                                >{pin}</li>
                                            ))}
                                        </ul>
                                    )}
                                    
                                </div>
                            </div>

                            <div className='col-md-2'>
                                <label className='form-label small-label'>Destination City</label>
                                <input 
                                className='form-control small-input' 
                                name='destCity'
                                value={formValues.destCity}
                                onChange={handleInputChange}
                                disabled/>
                            </div>

                            <div className='col-md-2'>
                                <label className='label-form small-label'>State Code</label>
                                <input className='form-control small-input' 
                                name='stateCode'
                                value={formValues.stateCode}
                                onChange={handleInputChange}
                                disabled></input>
                            </div>

                            <div className="col-md-2">
                                <label className="form-label small-label">Type
                                    <span className='text-danger'>*</span>
                                </label>
                                <div className="form-check form-check-inline ">
                                    <input
                                        type="radio"
                                        id="dox"
                                        name="docType"
                                        value="dox"
                                        className="form-check-input"
                                        checked={formValues.docType === 'dox'}
                                        style={{fontSize:'12px'}}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="dox" className="form-check-label" style={{fontSize:'12px'}}>Dox</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        id="non-dox"
                                        name="docType"
                                        value="non-dox"
                                        className="form-check-input"
                                        checked={formValues.docType === 'non-dox'}
                                        style={{fontSize:'12px'}}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="non-dox" className="form-check-label" style={{fontSize:'12px'}}>Non-Dox</label>
                                </div>
                            </div>

                            <div className='col-md-2'>
                                <label className='label-form small-label'>PCS
                                    <span className='text-danger'>*</span>
                                </label>
                                <input className='form-control small-input' 
                                name='pcs'
                                value={formValues.pcs}
                                onChange={handleNumberInputChange}
                                placeholder='Enter pcs'
                                />
                            </div>

                            <div className='col-md-2'>
                                <label className='form-label small-label'>Actual Weigth</label>
                                <input className='form-control small-input'
                                name='actualWt'
                                value={formValues.actualWt}
                                onChange={handleDecimalInputChange}
                                placeholder='Enter actual weigth'></input>
                            </div>

                            <div className='col-md-2'>
                                <label className='form-label small-label'>Volume Weigth</label>
                                <input className='form-control small-input' 
                                name='volumneWt'
                                ref={volRef}
                                value={formValues.volumneWt}
                                onChange={handleDecimalInputChange}
                                placeholder='Enter volume weigth'
                                onBlur={handleBlurOfVolumeWt}
                                onKeyDown={(e) => {
                                    if ((e.key === 'v' || e.key === 'V')) {
                                        e.preventDefault();   // optional (prevents typing Y)
                                        handleWeigthDimenstionFocus()
                                        formValues.awbNo.trim()!=='' &&
                                        0<Number(formValues.pcs)?setShowDimensionWeigthModal(true):setShowDimensionWeigthModal(false);
                                    }
                                }}/>
                            </div>

                            <div className='col-md-2 '>
                                <label className='form-label small-label'>Billing Weigth</label>
                                <input className='form-control small-input' 
                                name='billingWt'
                                value={formValues.billingWt}
                                onChange={handleDecimalInputChange}
                                disabled></input>
                            </div>

                        </div>

                        {/* <div className='row mb-3 align-items-center'>

                        </div> */}

                        <div className='row mb-3 align-items-center'>

                            <div className='col-md-2'>
                                <label className='form-label small-label'>Insurance</label>
                                {/* <input className='form-control small-input' 
                                name='insValue'
                                value={formValues.insurance}
                                disabled></input> */}

                                <select className='form-control small-input'
                                value={formValues.insurance}
                                name='insurance'
                                onChange={e=>{
                                    handleInputChange(e)
                                }}>
                                    <option value={'NA'}>NA</option>
                                    <option value={'Owner'}>Owner</option>
                                    <option value={'Carrier'}>Carrier</option>
                                </select>
                            </div>
                            <div className='col-md-2 '>
                                <label className='form-label small-label'>Ins. Invoice No.</label>
                                <input className='form-control small-input' 
                                name='insInvoiceNo'
                                value={formValues.insInvoiceNo}
                                onChange={handleInputChange}
                                disabled={isNA}
                                placeholder='Enter ins. invoice no.'></input>
                            </div>

                            <div className='col-md-2'>
                                <label className='form-label small-label'>Ins. Value</label>
                                <input className='form-control small-input' 
                                name='insValue'
                                value={formValues.insValue}
                                onChange={handleDecimalInputChange}
                                onBlur={OnBlurInsValue}
                                disabled={isNA}
                                placeholder='Enter ins. value'></input>
                            </div>
                        </div>

                        <div className='row mb-2 align-items-center'>
                            <div className='col-md-2'>
                                <label className='form-label font-18px d-flex align-items-center gap-2 small-label'>
                                    Sender Phone No.
                                    <span className='text-danger'>*</span>
                                    <input
                                        type='checkbox'
                                        className='form-check-input checkInput'
                                        name='selfClientSender'
                                        checked={clientSelfSender}
                                        style={{fontSize:'14px'}}
                                        onChange={handleInputChange}
                                    />
                                </label>
                                <input
                                    type="text"
                                    name="senderContact"
                                    className="form-control small-input"
                                    value={formValues.senderContact}
                                    onBlur={(e) => handleBlurSender(e)}
                                    onChange={handleInputChange}
                                    placeholder="Enter Sender Phone No."
                                />
                            </div>

                            <div className="col-md-3">
                                <label className="form-label small-label">Sender Name
                                    <span className='text-danger'>*</span>
                                </label>
                                <input
                                    type="text"
                                    name="senderName"
                                    className="form-control small-input"
                                    value={formValues.senderName}
                                    onChange={handleInputChange}
                                    placeholder="Enter Sender Name"
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label small-label">Sender Address
                                    <span className='text-danger'>*</span>
                                </label>
                                <input
                                    type="text"
                                    name="senderAddress"
                                    className="form-control small-input"
                                    value={formValues.senderAddress}
                                    onChange={handleInputChange}
                                    placeholder="Enter Sender Address"
                                />
                            </div>

                            <div className='col-md-1'>
                                <label className='form-label small-label'>Pincode
                                    <span className='text-danger'>*</span>
                                </label>
                                <div style={{position:"relative"}}>
                                    <input 
                                    className='form-control small-input' 
                                    name = "senderPincode" 
                                    autoComplete='off'
                                    // ref={senderPincodeRef}
                                    placeholder='Enter Sender pincode'
                                    value={formValues.senderPincode}
                                    onChange={e=>{
                                        handleInputChange(e);
                                        setActiveSenderIndex(-1);
                                    }}
                                    onBlur={e=>{
                                        handleBlurPincode('senderPincode');
                                        setTimeout(() => setFilteredSenderPincodes([]), 100);
                                    }}
                                    onKeyDown={(e)=>{
                                        if(e.key==="Tab"){
                                            setFilteredSenderPincodes([]);
                                            return;
                                        }
                                        else if (e.key === 'ArrowDown') {
                                            e.preventDefault();
                                            setActiveSenderIndex((prev) =>
                                                prev < filteredSenderPincodes.length - 1 ? prev + 1 : prev
                                            );
                                        } else if (e.key === 'ArrowUp') {
                                            e.preventDefault();
                                            setActiveSenderIndex((prev) => (prev > 0 ? prev - 1 : 0));
                                        } 
                                        // else if (e.key === 'Enter') {
                                        //     e.preventDefault();
                                        //     if (
                                        //         activeSenderIndex >= 0 &&
                                        //         activeSenderIndex < filteredSenderPincodes.length
                                        //     ) {
                                        //         selectSenderPincode(filteredSenderPincodes[activeSenderIndex]);
                                        //     }
                                        // }
                                    }}
                                    />
                                    {filteredSenderPincodes.length>0 && (
                                        <ul className='autocomplete'>
                                            {filteredSenderPincodes.map((pin,index)=>(
                                                <li className={activeSenderIndex===index?"active":""} key={index}
                                                onMouseDown={() => selectSenderPincode(pin)}
                                                >{pin}</li>
                                            ))}
                                        </ul>
                                    )}
                                    
                                </div>
                            </div>
                            <div className="col-md-1">
                                <label className="form-label small-label">City</label>
                                <input
                                    type="text"
                                    name="senderCity"
                                    className="form-control small-input"
                                    value={formValues.senderCity}
                                    onChange={handleInputChange}
                                    disabled
                                />
                            </div>
                            <div className="col-md-1">
                                <label className="form-label small-label">State</label>
                                <input
                                    type="text"
                                    name="senderState"
                                    className="form-control small-input"
                                    value={formValues.senderState}
                                    onChange={handleInputChange}
                                    disabled
                                />
                            </div>

                        </div>

                        <div className='row mb-2 align-items-center'>
                            <div className='col-md-2 '>
                                <label className='form-label small-label'> Receiver Phone No. 
                                    <span className='text-danger'>*</span>
                                </label>
                                <input
                                    type="text"
                                    name="receiverContact"
                                    className="form-control small-input"
                                    value={formValues.receiverContact}
                                    onBlur={(e) => handleBlurReceiver(e)}
                                    onChange={handleInputChange}
                                    placeholder="Enter Sender Phone No."
                                />
                            </div>

                            <div className="col-md-3">
                                <label className="form-label small-label">Receiver Name
                                    <span className='text-danger'>*</span>
                                </label>
                                <input
                                    type="text"
                                    name="receiverName"
                                    className="form-control small-input"
                                    value={formValues.receiverName}
                                    onChange={handleInputChange}
                                    placeholder="Enter Receiver Name"
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label small-label">Receiver Address
                                    <span className='text-danger'>*</span>
                                </label>
                                <input
                                    type="text"
                                    name="receiverAddress"
                                    className="form-control small-input"
                                    value={formValues.receiverAddress}
                                    onChange={handleInputChange}
                                    placeholder="Enter Receiver Address"
                                />
                            </div>

                            <div className='col-md-1'>
                                <label className='form-label small-label'>Pincode
                                    <span className='text-danger'>*</span>
                                </label>
                                <div style={{position:"relative"}}>
                                    <input 
                                    className='form-control small-input' 
                                    name = "receiverPincode" 
                                    autoComplete='off'
                                    ref={receiverPincodeRef}
                                    placeholder='Enter Receiver pincode'
                                    value={formValues.receiverPincode}
                                    onChange={e=>{
                                        handleInputChange(e);
                                        setActiveReceiverIndex(-1);
                                    }}
                                    onBlur={e=>{
                                        handleBlurPincode('receiverPincode');
                                        setTimeout(() => setFilteredReceiverPincodes([]), 100);
                                    }}
                                    onKeyDown={(e)=>{
                                        if(e.key==="Tab"){
                                            setFilteredReceiverPincodes([]);
                                            return;
                                        }
                                        else if (e.key === 'ArrowDown') {
                                            e.preventDefault();
                                            setActiveReceiverIndex((prev) =>
                                                prev < filteredReceiverPincodes.length - 1 ? prev + 1 : prev
                                            );
                                        } else if (e.key === 'ArrowUp') {
                                            e.preventDefault();
                                            setActiveReceiverIndex((prev) => (prev > 0 ? prev - 1 : 0));
                                        } 
                                        else if (e.key === 'Enter') {
                                            e.preventDefault();
                                            if (
                                                activeReceiverIndex >= 0 &&
                                                activeReceiverIndex < filteredReceiverPincodes.length
                                            ) {
                                                selectReceiverPincode(filteredReceiverPincodes[activeReceiverIndex]);
                                            }
                                        }
                                    }}
                                    />
                                    {filteredReceiverPincodes.length>0 && (
                                        <ul className='autocomplete'>
                                            {filteredReceiverPincodes.map((pin,index)=>(
                                                <li className={activeReceiverIndex===index?"active":""} key={index}
                                                onMouseDown={() => selectReceiverPincode(pin)}
                                                >{pin}</li>
                                            ))}
                                        </ul>
                                    )}
                                    
                                </div>
                            </div>
                            <div className="col-md-1">
                                <label className="form-label small-label">City</label>
                                <input
                                    type="text"
                                    name="receiverCity"
                                    className="form-control small-input"
                                    value={formValues.receiverCity}
                                    onChange={handleInputChange}
                                    disabled
                                />
                            </div>
                            <div className="col-md-1 ">
                                <label className="form-label small-label">State</label>
                                <input
                                    type="text"
                                    name="receiverState"
                                    className="form-control small-input"
                                    value={formValues.receiverState}
                                    onChange={handleInputChange}
                                    disabled
                                />
                            </div>

                        </div>

                        <div className='row mb-2 align-item-center'>

                            <div className='col-md-4 '>
                                <label className='form-label small-label'>Content</label>
                                <input className='form-control small-input' 
                                name='content'
                                value={formValues.content}
                                onChange={handleInputChange}
                                maxLength={50}
                                placeholder='Enter Content'></input>
                            </div>

                            <div className='col-md-6 mb-2'>
                                <label className='form-label small-label'>Remarks</label>
                                <input className='form-control small-input' 
                                name='remarks'
                                value={formValues.remarks}
                                onChange={handleInputChange}
                                maxLength={150}
                                placeholder='Enter remarks'/>
                            </div>
                        </div>

                        {/* <div className='row mb-3 align-item-center'>

                            <div className='col md-3 mb-2'>
                                <label className='form-label'>
                                    Consignee
                                </label>
                                <div style={{position:"relative"}}>
                                    <input 
                                    className='form-control' 
                                    name = "consignee" 
                                    autoComplete='off'
                                    placeholder='Enter consignee'
                                    value={formValues.consignee}
                                    maxLength={248}
                                    onChange={e=>{
                                        handleInputChange(e);
                                        setActiveConsigneeIndex(-1);
                                    }}
                                    onBlur={e=>{
                                        setTimeout(() => setFilterConsignee([]), 100);
                                    }}
                                    onKeyDown={(e)=>{
                                        if(e.key==="Tab"){
                                            setActiveConsigneeIndex([]);
                                            return;
                                        }
                                        else if (e.key === 'ArrowDown') {
                                            e.preventDefault();
                                            setActiveConsigneeIndex((prev) =>
                                                prev < filterConsignee.length - 1 ? prev + 1 : prev
                                            );
                                        } else if (e.key === 'ArrowUp') {
                                            e.preventDefault();
                                            setActiveConsigneeIndex((prev) => (prev > 0 ? prev - 1 : 0));
                                        } else if (e.key === 'Enter') {
                                            e.preventDefault();
                                            if (
                                                activeConsigneeIndex >= 0 &&
                                                activeConsigneeIndex < filterConsignee.length
                                            ) {
                                                selectConsignee(filterConsignee[activeConsigneeIndex]);
                                            }
                                        }
                                    }}
                                    />
                                    {filterConsignee.length>0 && (
                                        <ul className='autocomplete'>
                                            {filterConsignee.map((pin,index)=>(
                                                <li className={activeConsigneeIndex===index?"active":""} key={index}
                                                onMouseDown={() => selectConsignee(pin)}
                                                >{pin}</li>
                                            ))}
                                        </ul>
                                    )}
                                    
                                </div>
                            </div>
                        </div> */}

                        
                        <div className="d-flex justify-content-center">
                            <div className='col-md-2 mb-2 me-5 '>
                                <label className='form-label font-18px d-flex align-items-center gap-2'>
                                    <input
                                        type='checkbox'
                                        className='form-check-input'
                                        name='printDocket'
                                        checked={printDocket}
                                        style={{fontSize:'14px'}}
                                        onChange={handleInputChange}
                                    />
                                    Print 
                                </label>
                            </div>

                            <button type="button" name='saveBtn' className="btn btn-primary me-5" style={{ width: "100px" }} onClick={checkValidation} disabled={isSaveDisable}>
                                Save
                            </button>
                            <button type="button" className="btn btn-secondary" style={{ width: "100px" }} onClick={resetAction}>
                                Reset
                            </button>
                        </div>
                    </form>
                </section>
            </div>

            {showDimensionWeigthModal && (
                <>
                    <div className="modal fade show d-block" tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">

                                <div className="modal-header">
                                    <h5 className="modal-title">Weigth Dimension Calculator</h5>
                                    <button 
                                        type="button" 
                                        className="btn-close" 
                                        onClick={() => {
                                            setShowDimensionWeigthModal(false)
                                            setFocusVolumeWeigth(true);
                                        }}
                                    ></button>
                                </div>

                                <div className="modal-body">
                                    <form onKeyDown={handleEnterAsTabForVolumatric}>
                                        <div className='row mb-3 align-item-center'>

                                            <div className='col-md-2 mb-2'>
                                                <label className='form-label'>
                                                    PCS
                                                </label>
                                                <input className='form-control' ref={pcsRef}
                                                value={weigthDimension.pcs} 
                                                onChange={handleWeigthDecimalInputChange}
                                                name='pcs'
                                                // disabled
                                                />
                                            </div>

                                            <div className='col-md-2 mb-2'>
                                                <label className='form-label'>Heigth</label>
                                                <input className='form-control' 
                                                name='heigth'
                                                value={weigthDimension.heigth}
                                                onChange={handleWeigthDecimalInputChange}
                                                />
                                            </div>

                                            <div className='col-md-2 mb-2'>
                                                <label className='form-label'>Width</label>
                                                <input className='form-control' 
                                                name='width'
                                                value={weigthDimension.width}
                                                onChange={handleWeigthDecimalInputChange}
                                                />
                                            </div>
                                            <div className='col-md-2 mb-2'>
                                                <label className='form-label'>Length</label>
                                                <input className='form-control' 
                                                name='length'
                                                value={weigthDimension.length}
                                                onChange={handleWeigthDecimalInputChange}
                                                />
                                            </div>
                                            <div className='col-md-2 mb-2'>
                                                <label className='form-label'>Act Wt</label>
                                                <input className='form-control' 
                                                name='actwt'
                                                value={weigthDimension.actwt}
                                                onChange={handleWeigthDecimalInputChange}
                                                onKeyDown={(e)=>{
                                                    // if(e.key==='Enter' && getCookie(APP_TYPE_COOKIE_NAME)=== MMB_LIVE){
                                                    //     // enterDimensionMMB_LIVE();
                                                    // }else if(e.key==='Enter' && getCookie(APP_TYPE_COOKIE_NAME)=== MMB){
                                                    //     // enterDimensionMMB();
                                                    // }
                                                }}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                    <div className='row mb-3'>
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table table-sm table-bordered table-striped text-center align-middle">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th style={{width: "60px"}}>S.No</th>
                                                            <th style={{width: "80px"}}>PCS</th>
                                                            <th>Height</th>
                                                            <th>Width</th>
                                                            <th>Length</th>
                                                            <th>Act Wt</th>
                                                            <th>Vol Wt</th>
                                                            <th>Remove</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {dimensionList?.length > 0 ? (
                                                            dimensionList.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.pcs}</td>
                                                                    <td>{item.heigth}</td>
                                                                    <td>{item.width}</td>
                                                                    <td>{item.length}</td>
                                                                    <td>{item.actwt}</td>
                                                                    <td>{item.volwt}</td>
                                                                    <td><button className="btn btn-secondary" 
                                                                    onClick={()=>removeEnteredDimension(index)}
                                                                    disabled={isSaveDisable}>remove</button></td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="8" className="text-muted">
                                                                    No Data Added
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Background Overlay */}
                    <div className="modal-backdrop fade show"></div>
                </>
            )}
            <ToastContainer
                position="bottom-right"
                style={{ bottom: "60px", right: "40px" }}
                />

        </div>
    </>
  )
}

export default CreditBooking
